import { AppShell, ScrollArea } from '@mantine/core';
import { BookOpen, CircleHelp, Folder, LayoutDashboard, Tag } from 'lucide-react';
import { useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import { usePostStore } from '../../store/postStore';

interface SidebarProps {
  onNavigate?: () => void;
}

export const Sidebar = ({ onNavigate }: SidebarProps) => {
  const navigate = useNavigate();
  const user = useAuthStore((state) => state.user);
  const { categories, tags, fetchCategories, fetchTags } = usePostStore();

  useEffect(() => {
    if (!user) return;
    if (categories.length === 0) fetchCategories();
    if (tags.length === 0) fetchTags();
  }, [categories.length, fetchCategories, fetchTags, tags.length, user]);

  const search = (kind: 'category' | 'tag', value: string) => {
    navigate(`/search?${kind}=${encodeURIComponent(value)}`);
    onNavigate?.();
  };

  return (
    <AppShell.Navbar className="atlas-sidebar">
      <ScrollArea className="atlas-sidebar__scroll">
        <div className="rail-section">
          <div className="rail-label">Workspace</div>
          <NavLink to="/" end onClick={onNavigate}><BookOpen size={16} />Library</NavLink>
          <NavLink to="/about" onClick={onNavigate}><CircleHelp size={16} />About Luna</NavLink>
          {user?.role === 'administrator' && <NavLink to="/admin" onClick={onNavigate}><LayoutDashboard size={16} />Manage</NavLink>}
        </div>

        {categories.length > 0 && (
          <div className="rail-section">
            <div className="rail-label">Collections</div>
            {categories.slice(0, 6).map((category) => (
              <button key={category.name} onClick={() => search('category', category.name)}><Folder size={15} /><span>{category.name}</span></button>
            ))}
          </div>
        )}

        {tags.length > 0 && (
          <div className="rail-section">
            <div className="rail-label">Popular topics</div>
            {tags.slice(0, 7).map((tag) => (
              <button key={tag.name} onClick={() => search('tag', tag.name)}><Tag size={14} /><span>{tag.name}</span><small>{tag.count}</small></button>
            ))}
          </div>
        )}
      </ScrollArea>
      <div className="atlas-sidebar__footer">
        <span>Luna</span>
        <small>Writeups kept whole, so they still work months later.</small>
      </div>
    </AppShell.Navbar>
  );
};
